import TrimbleMaps, { RouteOptions } from '@trimblemaps/trimblemaps-js'

export const DEFAULT_MAP_CENTER = new TrimbleMaps.LngLat(-90.755043, 39.976473) // DOT HQ
export const ROUTE_OPTIONS: RouteOptions = {
  profileId: Number(process.env.REACT_APP_TRIMBLE_MAPS_PROFILE_ID),
  showStops: true, 
  routeColor: 'rgba(0, 0, 255, .75)',
  frameOptions: {
    padding: {
      top: document.documentElement.clientHeight / Math.log2(document.documentElement.clientHeight),
      bottom: document.documentElement.clientHeight / Math.log2(document.documentElement.clientHeight),
      left: document.documentElement.clientHeight / Math.log2(document.documentElement.clientHeight),
      right: document.documentElement.clientHeight / Math.log2(document.documentElement.clientHeight),
    },
  },
}